import { useTranslation } from "@/hooks/useTranslation/useTranslation"
import { useLayoutStore } from "@/store/layoutStore"
import { classNames } from "@/utils/classNames"
import { IconX } from "@tabler/icons-react"
import { createPortal } from "react-dom"

export interface ModalBaseProps extends React.PropsWithChildren {
  onClose?: () => void
  showSidebarLeft?: boolean
  overshadowContentRight?: boolean
  fullScreen?: boolean
  compact?: boolean
  modalTestId?: string
}

export const ModalBase: React.FC<ModalBaseProps> = ({
  onClose,
  showSidebarLeft = false,
  overshadowContentRight = false,
  fullScreen = false,
  compact = false,
  children,
  modalTestId,
}) => {
  const { translate } = useTranslation()
  const { isSidebarOpen } = useLayoutStore()

  const modalContent = (
    <div
      data-testid={modalTestId}
      className={classNames(
        "fixed inset-y-0",
        compact ? "left-0 right-[500px]" : "inset-x-0",
        !compact && showSidebarLeft
          ? isSidebarOpen
            ? "left-64"
            : "left-12"
          : "",
        compact ? "z-60" : "z-50",
        "justify-center bg-black/50 p-6",
      )}
      style={{ marginTop: 0 }}
    >
      <div
        className={classNames(
          "relative overflow-hidden",
          fullScreen ? "h-full w-full" : "h-full",
          overshadowContentRight && !fullScreen
            ? "w-[calc(100%-300px)]"
            : "w-full",
          "rounded-lg bg-grey1 p-6 shadow-lg",
        )}
      >
        {onClose && (
          <button
            className="absolute right-2 top-2 flex items-center text-xs text-white hover:text-grey5"
            onClick={onClose}
          >
            {translate("CLOSE")} <IconX />
          </button>
        )}
        {children}
      </div>
    </div>
  )

  if (typeof document === "undefined") {
    return modalContent
  }

  return createPortal(modalContent, document.body)
}
